import uniqueId from '@/helpers/unique-id';

const colorMap = [
  {
    range: [0, 4],
    colors: ['rgb(241,91,91)', 'rgb(218,31,61)'],
  },
  {
    range: [4, 6],
    colors: ['rgb(214,210,209)', 'rgb(241,91,91)'],
  },
  {
    range: [6, 8],
    colors: ['rgb(169,213,145)', 'rgb(214,210,209)'],
  },
  {
    range: [8, 10],
    colors: ['rgb(45,164,74)', 'rgb(169,213,145)'],
  },
];

const interpolateColor = (color1, color2, factor = 0.5) => {
  const result = color1.slice();
  let i = 0;

  while (i < 3) {
    result[i] = Math.round(result[i] + factor * (color2[i] - color1[i]));

    i += 1;
  }

  return result;
};

// My function to interpolate between two colors completely, returning an array
const interpolateColors = (steps, colors) => {
  const stepFactor = 1 / (steps - 1);
  const interpolatedColorArray = [];
  const color1 = colors[0].match(/\d+/g).map(Number);
  const color2 = colors[1].match(/\d+/g).map(Number);
  let i = 0;

  if (steps === 1) {
    interpolatedColorArray.push(color2);
  } else {
    while (i < steps) {
      interpolatedColorArray.push(interpolateColor(color1, color2, stepFactor * i));

      i += 1;
    }
  }

  return interpolatedColorArray;
};

const setColors = (items) => {
  colorMap.forEach((map) => {
    // const elements = items.filter((item) => (
    //   item.Mutatie > map.range[0] && item.Mutatie <= map.range[1]
    // ));
    // const colors = interpolateColors(elements.length, map.colors);

    // elements.forEach((obj, index) => {
    //   const element = obj;

    //   element.colors = `rgb(${colors[index][0]}, ${colors[index][1]}, ${colors[index][2]})`;
    // });

    Object.keys(items).forEach((key) => {
      const elements = items[key].filter((item) => (
        item.Rapportcijfer > map.range[0] && item.Rapportcijfer <= map.range[1]
      ));
      const colors = interpolateColors(elements.length, map.colors);

      elements.forEach((obj, index) => {
        const element = obj;

        element.colors = `rgb(${colors[index][0]}, ${colors[index][1]}, ${colors[index][2]})`;
      });
    });
  });
};

export default {
  fetchData: async (context) => {
    await fetch('./api/gemeente-data.json')
      .then((response) => response.json())
      .then((data) => {
        Object.keys(data).forEach((year) => {
          if (data[year][0].id === undefined) {
            const result = data[year].map((item) => {
              const obj = { ...item };

              obj.id = uniqueId('entry');

              return obj;
            });

            const small = result.filter((item) => item.Inwoners <= 25000);
            const medium = result.filter((item) => item.Inwoners > 25000 && item.Inwoners <= 50000);
            const normal = result.filter(
              (item) => item.Inwoners > 50000 && item.Inwoners <= 100000,
            );
            const large = result.filter((item) => item.Inwoners > 100000);

            const items = {
              small,
              medium,
              normal,
              large,
            };

            setColors(items);

            context.commit('setData', { result, year });
            context.commit('setSepData', { items, year });
          }
        });
      });
  },
};
